import "../../css/pc/mainWindow.css";
import WorkOrderItems from "./lists/WorkOrderItems";
import EltelLogo from "../../img/eltel.png";
import Front1 from "../../img/front1.jpg";
import Front2 from "../../img/front2.jpg";
import TextBoxSearch from "./controls/TextBoxSearch";
import { FaSearch } from "react-icons/fa";
import { useState, useEffect, useCallback } from "react";
import NewWoMainWindow from "./NewWO/NewWoMainWindow";
import MainWindowGrouped from "./NewWO/MainWindowGrouped";
import ExistingWOMain from "./ExistingWO/ExistingWOMain";
import DropDownSearchLeft from "./controls/DropDownSearchLeft";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "./controls/SignInButton";
import { SignOutButton } from "./controls/SignOutButton";
import { useMsal, MsalAuthenticationTemplate } from "@azure/msal-react";
import { EventType, InteractionType } from "@azure/msal-browser";
import {
  b2cPolicies,
  buildInvitationLoginRequest,
  loginRequest,
  protectedResources,
} from "../../authConfig";
import MainAdmin from "./admin/MainAdmin";
import { compareIssuingPolicy } from "./utils/claimUtils";
import {
  Container,
  Row,
  Col,
  Card,
  Navbar,
  Nav,
  Button,
  Dropdown,
} from "react-bootstrap";
import {
  FaUserShield,
  FaPlus,
  FaRegUser,
  FaBars,
  FaRegFolderOpen,
  FaQuestionCircle,
} from "react-icons/fa";
import { VscClose } from "react-icons/vsc";
import { useClarityEventTracking } from "./hooks/useClarityTracking";
import VersionBadge from "./controls/VersionBadge";
import AgreementSelect from "./controls/AgreementSelect";
import { use } from "react";

const MainWindowContent = () => {
  const ApiDomain = import.meta.env.VITE_BACKEND_API_HOST;
  const [showCreateWO, setShowCreateWO] = useState(false);
  const [showWIinfo, setShowWOinfo] = useState(false);
  const [showAdmin, setShowWAdmin] = useState(false);
  const [item, setItem] = useState("");
  const [status, setStatus] = useState("");
  const [searchText, setSearchText] = useState("");
  const [userSetting, setUserSetting] = useState({
    CustomerNo: "",
    Agreements: "",
  });
  const [workOrderListData, setWorkOrderListData] = useState([]);
  const [workOrderListError, setWorkOrderListError] = useState(false);
  const [showWoList, setShowWoList] = useState(false);
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();
  const [showSavedWorkOrders, setShowSavedWorkOrders] = useState(0);
  const [deepLinkedWorkOrder, setDeepLinkedWorkOrder] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(100);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoadingWoList, setIsLoadingWoList] = useState(false);
  const trackEvent = useClarityEventTracking();
  const [customerAgreements, setCustomerAgreements] = useState([]);
  const [selectedAgreementId, setSelectedAgreementId] = useState("");
  const [agreementsReady, setAgreementsReady] = useState(false);

  useEffect(() => {
    const callbackId = instance.addEventCallback((event) => {
      if (
        (event.eventType === EventType.LOGIN_SUCCESS ||
          event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) &&
        event.payload.account
      ) {
        /**
         * Below we are checking if the user is returning from the reset password flow.
         * If so, we will ask the user to reauthenticate with their new password.
         * If you do not want this behavior and prefer your users to stay signed in instead,
         * you can replace the code below with the same pattern used for handling the return from
         * profile edit flow
         */
        if (
          compareIssuingPolicy(
            event.payload.idTokenClaims,
            b2cPolicies.names.forgotPassword,
          )
        ) {
          let signUpSignInFlowRequest = {
            authority: b2cPolicies.authorities.signUpSignIn.authority,
            scopes: [
              ...protectedResources.apiTodoList.scopes.read,
              ...protectedResources.apiTodoList.scopes.write,
            ],
          };
          instance.loginRedirect(signUpSignInFlowRequest);
        }
      }

      if (event.eventType === EventType.LOGIN_FAILURE) {
        // Check for forgot password error
        if (event.error && event.error.errorMessage.includes("AADB2C90118")) {
          const resetPasswordRequest = {
            authority: b2cPolicies.authorities.forgotPassword.authority,
            scopes: [],
          };
          instance.loginRedirect(resetPasswordRequest);
        }
      }
    });

    return () => {
      if (callbackId) {
        instance.removeEventCallback(callbackId);
      }
    };
    // eslint-disable-next-line
  }, [instance]);

  // Handle deep linking on both direct visits and after authentication redirects
  useEffect(() => {
    const path = window.location.pathname;
    const pathMatch = path.match(/\/workorder\/(\d+)/);

    if (pathMatch) {
      setDeepLinkedWorkOrder(pathMatch[1]);
      return;
    }

    // If no direct match and user is authenticated, check for a saved redirect path
    if (isAuthenticated) {
      const redirectPath = sessionStorage.getItem("redirectPath");
      if (redirectPath) {
        const redirectMatch = redirectPath.match(/\/workorder\/(\d+)/);
        if (redirectMatch) {
          setDeepLinkedWorkOrder(redirectMatch[1]);
        }
        // Clear the redirect path so it doesn't trigger again
        sessionStorage.removeItem("redirectPath");
      }
    }
  }, [isAuthenticated]);

  useEffect(() => {
    // Check if we have a deep linked workorder to find once the data is loaded
    if (deepLinkedWorkOrder && workOrderListData.length > 0) {
      const foundWorkOrder = workOrderListData.find(
        (wo) =>
          wo.wono === deepLinkedWorkOrder || wo.WO_NO === deepLinkedWorkOrder,
      );
      if (foundWorkOrder) {
        setItem(foundWorkOrder);
        setShowWOinfo(true);
        setDeepLinkedWorkOrder(null); // Clear so it doesn't trigger again
      }
    }
  }, [workOrderListData, deepLinkedWorkOrder]);

  const clickButton = (e) => {
    setShowSavedWorkOrders(0);
    setShowCreateWO(true);
  };

  const clickShowSavedWorkOrders = (e) => {
    setShowSavedWorkOrders(1);
    setShowCreateWO(true);
    trackEvent("Påbörjat ej skickade");
  };

  const clickToggleWorkOrderList = (e) => {
    setShowWoList(!showWoList);
  };

  const clickButtonAdmin = (e) => {
    setShowWAdmin(true);
  };

  function updateWoList() {
    if (userSetting.CustomerNo.length !== 0) {
      getInstance("WOLIST");
    }
  }

  async function ShowWoinfo(WOitem) {
    setItem(WOitem);
    setShowWOinfo(true);
  }
  useEffect(() => {
    console.log({ accounts });
  }, [accounts]);
  function getInstance(type, pageNumber = null) {
    instance
      .acquireTokenSilent({
        ...loginRequest,
        account: accounts[0],
      })
      .then((response) => {
        if (type === "WOLIST") {
          myFetch(response, pageNumber);
        } else if (type === "USERSETTING") {
          myFetchUserSettings(response);
        } else if (type === "AGREEMENTS") {
          fetchAgreements(response);
        }
      })
      .catch((error) => {
        instance
          .acquireTokenPopup({
            ...loginRequest,
            account: accounts[0],
          })
          .then((response) => {
            if (type === "WOLIST") {
              myFetch(response);
            } else if (type === "USERSETTING") {
              myFetchUserSettings(response);
            }
            console.log(error);
          });
      });
  }

  function shouldWaitForAgreementSelection() {
    const hasSelectableAgreements =
      (userSetting?.Agreements || "")
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean).length > 0;

    return (
      userSetting?.HasExtraProducts &&
      hasSelectableAgreements &&
      !selectedAgreementId
    );
  }

  useEffect(() => {
    if (
      userSetting.CustomerNo.length !== 0 &&
      agreementsReady &&
      !shouldWaitForAgreementSelection()
    ) {
      setCurrentPage(1);
      getInstance("WOLIST", 1);
    }
  }, [
    status,
    selectedAgreementId,
    agreementsReady,
    userSetting.CustomerNo,
    userSetting.HasExtraProducts,
    userSetting.Agreements,
  ]);

  useEffect(() => {
    if (isAuthenticated) {
      getInstance("USERSETTING");
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (
      isAuthenticated &&
      userSetting &&
      userSetting.CustomerNo.length !== 0 &&
      userSetting.HasExtraProducts
    ) {
      getInstance("AGREEMENTS");
    }
  }, [userSetting, isAuthenticated]);

  function myFetch(response, pageNumber = null) {
    const hasSelectableAgreements =
      (userSetting?.Agreements || "")
        .split(",")
        .map((x) => x.trim())
        .filter(Boolean).length > 0;

    const mustWaitForAgreementSelection =
      userSetting?.HasExtraProducts &&
      hasSelectableAgreements &&
      !selectedAgreementId;

    if (mustWaitForAgreementSelection) {
      return;
    }

    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
      method: "GET",
      headers: headers,
    };

    setWorkOrderListData([]);
    setIsLoadingWoList(true);

    // Use passed page number if available, otherwise use currentPage state
    const pageToFetch = pageNumber ? pageNumber : Math.max(1, currentPage);

    // Build URL with pagination parameters
    let baseUrl = `https://${ApiDomain}/Ora/ora/get/wo/list?customer_no=${userSetting.CustomerNo}&pageNumber=${pageToFetch}&pageSize=${pageSize}`;

    if (selectedAgreementId && userSetting.HasExtraProducts) {
      baseUrl += `&agreement=${selectedAgreementId}`;
    }

    // Add optional parameters
    const params = [];
    if (status !== "na") {
      params.push(`status=${status}`);
    }
    if (searchText) {
      params.push(`searchText=${searchText}`);
    }

    const url = params.length > 0 ? `${baseUrl}&${params.join("&")}` : baseUrl;

    const res = fetch(url, options)
      .then(function (response) {
        if (!response.ok) {
          setWorkOrderListError(true);
        }
        return response.json();
      })
      .then((data) => {
        setTotalPages(Math.max(1, data.TotalPages));
        setCurrentPage(data.PageNumber);

        // Sort items by registration date
        const sortedItems = data.Items.sort((a, b) => {
          return new Date(b.REG_DATE) - new Date(a.REG_DATE);
        });
        setWorkOrderListData(sortedItems);
      })
      .catch((error) => console.log(error))
      .finally(() => setIsLoadingWoList(false));
  }

  function myFetchUserSettings(response) {
    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
      method: "GET",
      headers: headers,
    };

    let url = "";
    url = `https://${ApiDomain}/usersettings/sql/get/user/settings`;
    const res = fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        setUserSetting(data);
        if (!data?.HasExtraProducts) {
          setAgreementsReady(true);
        } else {
          setAgreementsReady(false);
        }
      })
      .catch((error) => console.log(error));
  }
  const getWorkOrderListSearch = async () => {
    setCurrentPage(1); // Reset to first page when searching
    getInstance("WOLIST");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      getInstance("WOLIST");
    }
  };

  function disableCreateWorkOrderButton() {
    if (
      userSetting.CustomerNo.length === 0 ||
      userSetting.Agreements.length === 0
    ) {
      return true;
    }
    return false;
  }

  const fetchAgreements = useCallback(
    async (authResponse) => {
      const headers = new Headers();
      const bearer = `Bearer ${authResponse.accessToken}`;
      headers.append("Authorization", bearer);

      const options = {
        method: "GET",
        headers: headers,
      };

      const targetCustomer = userSetting.CustomerNo;
      const url = `https://${ApiDomain}/customer/${targetCustomer}/agreements`;

      try {
        const response = await fetch(url, options);
        const data = await response.json();
        setCustomerAgreements(Array.isArray(data) ? data : []);
        setAgreementsReady(true);
        return data;
      } catch (error) {
        console.log("Error fetching agreements:", error);
        setCustomerAgreements([]);
        setAgreementsReady(true);
        return [];
      }
    },
    [ApiDomain, userSetting.CustomerNo],
  );

  useEffect(() => {
    if (!userSetting?.HasExtraProducts) {
      setAgreementsReady(true);
    }
  }, [userSetting]);

  useEffect(() => {
    if (!userSetting?.HasExtraProducts) {
      setSelectedAgreementId("");
      return;
    }

    const agreementIds = (userSetting?.Agreements || "")
      .split(",")
      .map((x) => x.trim())
      .filter(Boolean);

    if (agreementIds.length > 0 && !selectedAgreementId) {
      setSelectedAgreementId(agreementIds[0]);
    }
  }, [userSetting, selectedAgreementId]);

  const refresh = () => window.location.reload(true);

  const selectedAgreementName =
    customerAgreements.find(
      (x) => String(x.AgreementId) === String(selectedAgreementId),
    )?.AgreementName || "Namn saknas";

  return (
    <Container fluid>
      <Row style={{ minHeight: "100vh" }}>
        <Col xs lg={4} xl={3} className="leftDiv">
          <Container fluid>
            <Row>
              <Navbar>
                <Container>
                  <Navbar.Brand>
                    <img
                      src={EltelLogo}
                      alt="eltellogo"
                      className="logo"
                      onClick={refresh}
                    />
                    <span className="separator_line"></span>
                    <span style={{ color: "#ffffff", fontSize: "1rem" }}>
                      Self Service Portal
                    </span>
                  </Navbar.Brand>
                  <Nav className="d-lg-none d-flex">
                    {isAuthenticated ? (
                      <>
                        <Button
                          variant="primary"
                          onClick={clickButton}
                          className="create-workorder-button"
                          style={{ padding: "8px 10px" }}
                          disabled={disableCreateWorkOrderButton()}
                        >
                          <FaPlus
                            style={{
                              margin: "0",
                              fontSize: "1.2em",
                              verticalAlign: "sub",
                            }}
                          />
                        </Button>
                        <Button
                          variant="primary"
                          onClick={clickShowSavedWorkOrders}
                          className="create-workorder-button"
                          style={{ padding: "8px 10px" }}
                          disabled={disableCreateWorkOrderButton()}
                        >
                          <FaRegFolderOpen
                            style={{
                              margin: "0",
                              fontSize: "1.2em",
                              verticalAlign: "sub",
                            }}
                          />
                        </Button>
                      </>
                    ) : (
                      <></>
                    )}
                    <Button
                      onClick={clickToggleWorkOrderList}
                      className="show-workorders-button"
                    >
                      {showWoList ? (
                        <VscClose
                          style={{
                            margin: "0",
                            fontSize: "2.5em",
                            verticalAlign: "sub",
                          }}
                        />
                      ) : (
                        <FaBars
                          style={{
                            margin: "0",
                            fontSize: "2em",
                            verticalAlign: "sub",
                          }}
                        />
                      )}
                    </Button>
                  </Nav>
                </Container>
              </Navbar>
              <Container style={{ backgroundColor: "#ffffff" }}>
                <Navbar
                  className={
                    showWoList
                      ? "d-lg-none justify-content-center py-0"
                      : "d-none"
                  }
                >
                  <Nav className="align-items-center">
                    <Nav.Item>
                      <div className="me-2 text-uppercase">
                        <FaRegUser className="icon me-1 mb-1" />
                        {isAuthenticated ? accounts[0].name : " "}
                      </div>
                    </Nav.Item>
                    <Nav.Item>
                      <div className="vr menu-divider mx-4 d-block"></div>
                    </Nav.Item>
                    <Nav.Item className="mobile-sign-out-button">
                      {isAuthenticated ? <SignOutButton /> : <SignInButton />}
                    </Nav.Item>
                  </Nav>
                </Navbar>
              </Container>
            </Row>
            <Row className={showWoList ? "" : "d-none d-lg-block"}>
              {" "}
              {/* Hide on screens smaller than lg or display if showWoList is true */}
              <Col>
                <TextBoxSearch
                  searchText={searchText}
                  setSearchText={setSearchText}
                  handleKeyDown={handleKeyDown}
                />
                <FaSearch
                  className="fasearch"
                  onClick={getWorkOrderListSearch}
                />
                <DropDownSearchLeft
                  status={status}
                  setStatus={setStatus}
                  workOrderFilter={userSetting.WorkOrderFilter}
                  updateWoList={updateWoList}
                  disabled={isLoadingWoList}
                />
                {workOrderListError ? (
                  <div className="errorMessage">
                    Det går inte att hämta arbetsordrar just nu, ladda om sidan
                    för att försöka igen eller kontakta Eltel SPOC om problemet
                    kvarstår.
                  </div>
                ) : workOrderListData.length > 0 ? (
                  <WorkOrderItems
                    ShowWoinfo={ShowWoinfo}
                    workOrderListData={workOrderListData}
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={(pageNumber) => {
                      const fetchPage = async () => {
                        setCurrentPage(pageNumber);
                        getInstance("WOLIST", pageNumber);
                      };
                      fetchPage();
                    }}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          </Container>
        </Col>
        <Col
          lg={8}
          xl={9}
          className={showWoList ? "d-none" : "mainContent align-items-center"}
        >
          <VersionBadge />
          <Navbar bg="transparent" className="d-none d-lg-block">
            <Container>
              <Nav>
                <Nav.Item
                  className="me-2 d-flex align-items-center"
                  style={{ marginTop: "2px" }}
                >
                  {isAuthenticated && userSetting.HasExtraProducts ? (
                    <AgreementSelect
                      userSetting={userSetting}
                      customerAgreements={customerAgreements}
                      selectedAgreementId={selectedAgreementId}
                      setSelectedAgreementId={setSelectedAgreementId}
                    />
                  ) : null}
                </Nav.Item>
                <Nav.Item>
                  {isAuthenticated ? (
                    <>
                      <Button
                        variant="primary"
                        onClick={clickButton}
                        className="create-workorder-button"
                        disabled={disableCreateWorkOrderButton()}
                      >
                        <FaPlus className="icon" />
                        Skapa beställning
                      </Button>
                      <Button
                        variant="primary"
                        onClick={clickShowSavedWorkOrders}
                        className="create-workorder-button"
                        disabled={disableCreateWorkOrderButton()}
                      >
                        <FaRegFolderOpen className="icon" />
                        Påbörjat ej skickade
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                </Nav.Item>
              </Nav>
              <Nav className="justify-content-end align-items-center">
                <Nav.Item>
                  <Dropdown>
                    <Dropdown.Toggle as="span" id="help-dropdown">
                      <FaQuestionCircle
                        className="icon me-3 mb-1"
                        size={20}
                        style={{ cursor: "pointer" }}
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        as="a"
                        href="/documents/Användarmanual Eltel Self Service Portal - Svenska v1.1.pdf"
                        download="Användarmanual Eltel Self Service Portal - Svenska.pdf"
                      >
                        Manual SWE
                      </Dropdown.Item>
                      <Dropdown.Item
                        as="a"
                        href="/documents/Användarmanual Eltel Self Service Portal - Engelska v.1.0.pdf"
                        download="Användarmanual Eltel Self Service Portal - English.pdf"
                      >
                        Manual ENG
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Nav.Item>
                <Nav.Item>
                  <div className="me-2 text-uppercase">
                    <FaRegUser className="icon me-1 mb-1" />
                    {isAuthenticated ? accounts[0].name : " "}
                  </div>
                </Nav.Item>
                <Nav.Item>
                  <div className="vr menu-divider me-1 mt-1"></div>
                </Nav.Item>
                <Nav.Item>
                  {isAuthenticated && userSetting.IsAdmin === true ? (
                    <Button
                      variant="primary"
                      onClick={clickButtonAdmin}
                      className="admin-button"
                    >
                      <FaUserShield className="icon" />
                      ADMIN
                    </Button>
                  ) : (
                    <></>
                  )}
                </Nav.Item>
                <Nav.Item>
                  {isAuthenticated ? <SignOutButton /> : <SignInButton />}
                </Nav.Item>
              </Nav>
            </Container>
          </Navbar>

          <Container className="h-75 justify-content-start" fluid>
            <Row className="align-items-center h-100">
              <Col lg={4}>
                <div className="d-lg-none w-100 position-relative welcome-images-mobile">
                  <img
                    src={Front2}
                    alt="eltelfront"
                    className="front2-mobile"
                  />
                  <img
                    src={Front1}
                    alt="eltelfront"
                    className="front1-mobile"
                  />
                </div>

                <Card bg="transparent" className="border-0 align-items-center">
                  <Card.Body>
                    <Card.Title>
                      Välkommen till Eltel
                      <br /> {isAuthenticated ? accounts[0].name : " "}
                    </Card.Title>
                    <Card.Text>
                      <p>
                        Har du frågor angående din <b>order</b>, vänligen
                        kontakta Eltel kundservice
                      </p>
                      Tel: 031-7454500
                      <br />
                      Mail:{" "}
                      <a href="mailto:SPOC.SWE@eltelnetworks.se">
                        SPOC.SWE@eltelnetworks.se
                      </a>
                      <br />
                      <br />
                      <p>
                        Har du frågor om vår <b>kundportal</b>
                        <br />
                        Kontakta oss här:
                        <br />
                        <a href="mailto:essp-customersupport@eltelnetworks.com">
                          essp-customersupport@eltelnetworks.com
                        </a>
                      </p>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
              <Col lg={3}>
                <div className="welcome-images d-none d-lg-block">
                  <img src={Front2} alt="eltelfront" className="front2" />
                  <img src={Front1} alt="eltelfront" className="front1" />
                </div>
              </Col>
            </Row>
          </Container>

          {showCreateWO ? (
            // <NewWoMainWindow
            //   setShowCreateWO={setShowCreateWO}
            //   customer_no={userSetting.CustomerNo}
            //   accounts={accounts[0]}
            //   updateWoList={updateWoList}
            //   showSavedWorkOrders={showSavedWorkOrders}
            //   setShowSavedWorkOrders={setShowSavedWorkOrders}
            // />
            <MainWindowGrouped
              setShowCreateWO={setShowCreateWO}
              customer_no={userSetting.CustomerNo}
              accounts={accounts[0]}
              updateWoList={updateWoList}
              showSavedWorkOrders={showSavedWorkOrders}
              setShowSavedWorkOrders={setShowSavedWorkOrders}
              hasExtraProducts={userSetting.HasExtraProducts ?? false}
              selectedAgreementId={selectedAgreementId}
              selectedAgreementName={selectedAgreementName}
            />
          ) : (
            <></>
          )}
          {showWIinfo ? (
            <ExistingWOMain
              item={item}
              setShowWOinfo={setShowWOinfo}
              showWIinfo={showWIinfo}
              user={accounts[0].name}
              updateWoList={updateWoList}
            />
          ) : (
            <></>
          )}
          {showAdmin ? <MainAdmin setShowWAdmin={setShowWAdmin} /> : <></>}
        </Col>
      </Row>
    </Container>
  );
};

export const MainWindow = () => {
  const isAuthenticated = useIsAuthenticated();
  const [invitationParams, setInvitationParams] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const idTokenHint = params.get("id_token_hint");

    if (!idTokenHint) {
      return null;
    }

    const nonce = params.get("nonce");

    return {
      idTokenHint,
      ...(nonce ? { nonce } : {}),
    };
  });

  // Save the current path to sessionStorage before authentication redirect
  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath !== "/" && currentPath !== "") {
      sessionStorage.setItem("redirectPath", currentPath);
    }
  }, []);

  useEffect(() => {
    if (!invitationParams) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    params.delete("id_token_hint");
    params.delete("nonce");

    const newSearch = params.toString();
    const newPath = newSearch
      ? `${window.location.pathname}?${newSearch}`
      : window.location.pathname;
    const hash = window.location.hash;

    window.history.replaceState(
      window.history.state,
      document.title,
      hash ? `${newPath}${hash}` : newPath,
    );
  }, [invitationParams]);

  useEffect(() => {
    if (isAuthenticated && invitationParams) {
      setInvitationParams(null);
    }
  }, [isAuthenticated, invitationParams]);

  const authenticationRequest = invitationParams
    ? buildInvitationLoginRequest(invitationParams)
    : loginRequest;

  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authenticationRequest}
    >
      <MainWindowContent />
    </MsalAuthenticationTemplate>
  );
};
